<template>
  <div>
    <div v-show="showTree">
      <div class="tab-title">我的家谱</div>
      <div class="tree-tab-container">
        <el-collapse v-model="activeNames">
          <el-collapse-item class="tree-item" name="1">
            <template slot="title">
              <p class="item-title">家训</p>
            </template>
            <UserTeach />
          </el-collapse-item>
          <el-collapse-item class="tree-item" name="2">
            <template slot="title">
              <p class="item-title">家谱</p>
            </template>
            <!-- <div class="item-menu-wrap">
              <ul>
                <li>放大家谱</li>
                <li>导出家谱</li>
              </ul>
            </div> -->
            <div class="family-tree-wrapper">
              <div>
                <ul class="tree-tab-wrap flex">
                  <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="{ active: active == index }"
                  >
                    <!-- <p class="tree-tab-btn" @click="toggle(index, tab.view)">
                      {{ tab.name }}
                    </p> -->
                    <el-dropdown @command="handleTreeAction">
                      <p class="tree-tab-btn" @click="toggle(index, tab.view)">
                        {{ tab.name }}
                      </p>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{ action: 1, type: index }"
                          >放大家谱</el-dropdown-item
                        >
                        <!-- <el-dropdown-item :command="{ action: 2, type: index }"
                          >导出家谱</el-dropdown-item
                        > -->
                      </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <p v-if="active == index" class="view-big-tree">
                      <el-button @click="viewBigTree" class="handlian-btn"
                        >放大家谱</el-button
                      >
                    </p> -->
                  </li>
                </ul>
                <div class="add-member-wrap">
                  <a
                    href="javascript:void(0)"
                    class="add-member-btn"
                    @click="openSelectForm"
                    :class="initAddClass"
                    >手动完善家谱</a
                  >
                </div>
              </div>
              <div class="family-tree-container">
                <component :is="currentView" ref="treeTemp"></component>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item class="tree-item" name="3">
            <template slot="title">
              <p class="item-title">族谱</p>
            </template>
            <div class="family-clan-wrapper">
              <p class="clan-btn-wrap">
                <a
                  href="javascript:void(0)"
                  class="view-clan-btn clan-icon"
                  @click="viewClanTree"
                  >查看族谱</a
                >
                <a
                  href="javascript:void(0)"
                  class="view-clan-btn feed-icon"
                  @click="viewClanFeed"
                  >浏览族窗</a
                >
              </p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="wait-list-wrapper">
        <el-dialog
          title="选择亲人关系"
          :visible.sync="waitMemberVisible"
          width="550px"
          :close-on-click-modal="false"
          :destroy-on-close="true"
          :before-close="clearSelectForm"
          custom-class="handlian-share-feed"
          v-dialogDrag
        >
          <div class="wait-member-wrap">
            <div class="wait-member-container">
              <el-form
                :model="selectRelationForm"
                :rules="relationRules"
                ref="selectRelationForm"
                :inline="true"
                class="hl-form-inline"
              >
                <el-form-item prop="member" label="被添加人是">
                  <el-select
                    v-model="selectRelationForm.member"
                    @change="selectMemberChange"
                    placeholder="— 亲人 —"
                  >
                    <el-option
                      v-for="(item, index) in waitMemberList"
                      :key="index"
                      :label="item.userName"
                      :value="item.userId"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="relation" label="的">
                  <el-select
                    v-model="selectRelationForm.relation"
                    placeholder="— 关系 —"
                  >
                    <el-option
                      v-for="(item, index) in waitRelation"
                      :key="index"
                      :label="item.text"
                      :value="item.appellation"
                      :disabled="item.disabled"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    class="handlian-btn add-member-button"
                    type="primary"
                    @click="submitAddForm('selectRelationForm')"
                    >确定</el-button
                  >
                </el-form-item>
              </el-form>
              <div class="add-member-tip">
                提示：如果亲人在世，尽量使用申请传连，不用手动添加，因为只有传连他
                / 她才可以自主编辑传世的信息 。
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <div v-show="!showTree">
      <div>
        <component :is="userTab" :nodeInfo="nodeInfo"></component>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import UserTeach from "../../components/user/user-teach";
import FatherTree from "../../components/user/tree/father-tree";
import MotherTree from "../../components/user/tree/mother-tree";
import DeathUser from "../../components/user/tree/death-user";
import TempNode from "../../components/user/tree/temp-node";
import TrueUser from "../../components/user/tree/true-user";
import { apiMap } from "../../utils/apiMap";
import _ from "lodash";
// import $ from "jquery";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
export default {
  name: "user-tree",
  data() {
    var validateMember = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择亲人"));
      } else {
        callback();
      }
    };
    var validateRelation = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择关系"));
      } else {
        callback();
      }
    };
    return {
      activeNames: ["1", "2"],
      active: 0,
      currentView: "FatherTree",
      tabs: [
        {
          name: "父系家谱",
          type: "FatherTree",
          view: "FatherTree",
        },
        {
          name: "母系家谱",
          type: "FatherTree",
          view: "MotherTree",
        },
      ],
      showTree: true,
      userTab: "TrueUser",
      nodeInfo: {},
      waitMemberVisible: false,
      waitMemberList: [],
      selectRelationForm: {
        member: "",
        relation: "",
      },
      waitRelation: [
        { appellation: "父亲", text: "父亲", sex: 1, disabled: false },
        { appellation: "哥哥", text: "哥哥", sex: 1, disabled: false },
        { appellation: "姐姐", text: "姐姐", sex: 2, disabled: false },
        { appellation: "丈夫", text: "丈夫", sex: 1, disabled: true },
        { appellation: "妻子", text: "妻子", sex: 2, disabled: true },
        { appellation: "弟弟", text: "弟弟", sex: 1, disabled: false },
        { appellation: "妹妹", text: "妹妹", sex: 2, disabled: false },
        { appellation: "儿子", text: "儿子", sex: 1, disabled: true },
        { appellation: "儿女", text: "女儿", sex: 2, disabled: true },
      ],
      relationRules: {
        member: [{ validator: validateMember, trigger: "change" }],
        relation: [{ validator: validateRelation, trigger: "change" }],
      },
      htmlTitle: "测试PDF",
    };
  },
  components: {
    UserTeach,
    FatherTree,
    MotherTree,
    DeathUser,
    TempNode,
    TrueUser,
  },
  computed: {
    ...mapGetters(["waitMemberMap"]),
    initAddClass() {
      if (this.currentView == "FatherTree") {
        return "is-allowed";
      } else {
        return "not-allowed";
      }
    },
  },
  mounted() {
    this.$bus.$on("switch-tree-profile", this.switchTreeOrProfile);
  },
  methods: {
    toggle(i, v) {
      this.active = i;
      this.currentView = v;
    },
    switchTreeOrProfile(data) {
      if (data.hasOwnProperty("userId")) {
        this.showTree = false;
        this.nodeInfo = data;
        switch (data.userType) {
          case 0:
            this.userTab = "TrueUser";
            break;
          case 1:
            this.userTab = "TempNode";
            break;
          case 2:
            this.userTab = "DeathUser";
            break;
        }
      } else {
        this.showTree = true;
      }
    },
    getUserInstruction() {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      _this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["familyIntro"]["method"],
          url: apiMap["familyIntro"]["url"],
          params: {
            token: loginUser.token,
            count: 1,
            type: 1,
          },
        })
        .then(function(response) {
          // console.log(response.data);
          if (response.data.result.statusCode == 1) {
            if (scene == 1) {
              _this.editTeachForm.teacContent = response.data.result.data.text;
              _this.hasTeach.show = true;
              _this.hasTeach.userName =
                response.data.result.data.userInfo.realName;
              _this.hasTeach.addTime = _this.initAddTime(
                response.data.result.data.addTime
              );
            } else {
              _this.teachList = response.data.result.data;
            }
          } else {
            if (scene == 1) {
              var tempTeach =
                "家训是子孙立身处世、持家治业的行动指南和约束，也是家庭文化氛围、团结向上的象征。一般由家族中德高望重的人设立，或集体议定。";
              _this.editTeachForm.teacContent = tempTeach;
            } else {
              _this.listStatusText = "暂无记录";
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    openSelectForm() {
      if (this.currentView == "FatherTree") {
        this.waitMemberVisible = true;
        if (this.waitMemberMap.hasOwnProperty("ancestorNode")) {
          let ancestorNode = JSON.parse(this.waitMemberMap.ancestorNode);
          let maleNode = JSON.parse(this.waitMemberMap.maleNode);
          var waitMember = [];
          for (let d in ancestorNode) {
            const ancestor = maleNode[ancestorNode[d]];
            if (ancestor) {
              if (ancestor.userId && ancestor.sex) {
                waitMember.push(ancestor);
              }
            }
          }
          // birthIdArr = Array.from(sortBirth.map(d=>(d['userId'])));
          this.waitMemberList = _.sortBy(waitMember, ["generation"]);
        }
      }
    },
    clearSelectForm() {
      this.waitMemberVisible = false;
      this.selectRelationForm.member = "";
      this.selectRelationForm.relation = "";
    },
    submitAddForm(formName) {
      let _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          let members = _this.waitMemberList.filter(
            (item) => item.userId == _this.$refs[formName].model.member
          );
          let relations = _this.waitRelation.filter(
            (item) => item.appellation == _this.$refs[formName].model.relation
          );
          if (relations.length > 0 && members.length > 0) {
            let reverseCall = _this.reverseRelation(
              members[0]["sex"],
              relations[0]["sex"],
              relations[0]["text"]
            );
            let params = {
              action: "1",
              userId: members[0]["userId"], //已选的 '某人' 的ID
              userType: 1,
              relation: relations[0]["appellation"],
              reverseRelation: reverseCall,
              sex: relations[0]["sex"],
            };
            //打开编辑资料表单
            _this.switchTreeOrProfile(params);
            _this.clearSelectForm();
          }
        } else {
          return false;
        }
      });
    },
    reverseRelation(selectSex, newSex, call) {
      const map = new Map([
        [{ selectSex: 1, newSex: 1, call: "父亲" }, "儿子"], //给儿子添加父亲
        [{ selectSex: 2, newSex: 1, call: "父亲" }, "儿女"], //给女儿添加父亲

        [{ selectSex: 1, newSex: 1, call: "哥哥" }, "弟弟"], //给弟弟添加哥哥
        [{ selectSex: 2, newSex: 1, call: "哥哥" }, "妹妹"], //给妹妹添加哥哥
        [{ selectSex: 1, newSex: 2, call: "姐姐" }, "弟弟"], //给弟弟添加姐姐
        [{ selectSex: 2, newSex: 2, call: "姐姐" }, "妹妹"], //给妹妹添加姐姐

        [{ selectSex: 1, newSex: 1, call: "弟弟" }, "哥哥"], //给哥哥添加弟弟
        [{ selectSex: 2, newSex: 1, call: "弟弟" }, "姐姐"], //给姐姐添加弟弟
        [{ selectSex: 1, newSex: 2, call: "妹妹" }, "哥哥"], //给哥哥添加妹妹
        [{ selectSex: 2, newSex: 2, call: "妹妹" }, "姐姐"], //给姐姐添加妹妹

        [{ selectSex: 1, newSex: 2, call: "妻子" }, "丈夫"], //给丈夫添加妻子
        [{ selectSex: 2, newSex: 1, call: "丈夫" }, "妻子"], //给妻子添加丈夫

        [{ selectSex: 1, newSex: 1, call: "儿子" }, "父亲"], //给父亲添加儿子
        [{ selectSex: 1, newSex: 2, call: "女儿" }, "父亲"], //给父亲添加女儿
        [{ selectSex: 2, newSex: 1, call: "儿子" }, "母亲"], //给母亲添加儿子
        [{ selectSex: 2, newSex: 2, call: "女儿" }, "母亲"], //给母亲添加女儿
      ]);
      const item = [...map].filter(
        ([key, value]) =>
          key.selectSex === selectSex &&
          key.newSex === newSex &&
          key.call === call
      );
      const [key, value] = item[0];
      return value;
    },
    selectMemberChange(userId) {
      if (this.waitMemberMap.hasOwnProperty("ancestorNode")) {
        let maleNode = JSON.parse(this.waitMemberMap.maleNode);
        var ancestor = maleNode[userId];
        if (ancestor && ancestor.hasOwnProperty("sex")) {
          switch (ancestor.sex) {
            case 1:
              this.waitRelation[3].disabled = true;
              this.waitRelation[4].disabled = false;
              // this.waitRelation.splice(5, 1, { appellation: "妻子", sex: 2 });
              break;
            case 2:
              this.waitRelation[3].disabled = false;
              this.waitRelation[4].disabled = true;
              // this.waitRelation.splice(5, 1, { appellation: "丈夫", sex: 1 });
              break;
          }
        }
        let loginInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        if (loginInfo) {
          if (userId == loginInfo.userId.toString()) {
            this.setChildDisabled(2);
          } else {
            this.setChildDisabled(1);
          }
        } else {
          this.setChildDisabled(2);
        }
      }
    },
    setChildDisabled(condition) {
      if (condition == 1) {
        this.waitRelation[7].disabled = true;
        this.waitRelation[8].disabled = true;
      } else {
        this.waitRelation[7].disabled = false;
        this.waitRelation[8].disabled = false;
      }
    },
    viewBigTree() {
      var params = {};
      switch (this.active) {
        case 0:
          params = { type: "father" };
          break;
        case 1:
          params = { type: "mother" };
          break;
      }
      // this.$router.push({path:'bigTree',query:params});
      let routerTreeCard = this.$router.resolve({
        path: "bigTree",
        query: params,
      });
      window.open(routerTreeCard.href, "_blank");
    },
    viewClanTree() {
      let _this = this;
      _this.checkFamilyTree(function(res) {
        if (res == 1) {
          let routerClanCard = _this.$router.resolve({ path: "clanTree" });
          window.open(routerClanCard.href, "_blank");
        } else {
          _this.$message({
            message: "您暂无族谱",
            center: true,
            duration: 1500,
            offset: 60,
          });
        }
      });
    },
    viewClanFeed() {
      let _this = this;
      _this.checkFamilyTree(function(res) {
        if (res == 1) {
          let routerClanCard = _this.$router.resolve({ path: "clanFeed" });
          window.open(routerClanCard.href, "_blank");
        } else {
          _this.$message({
            message: "暂无族谱动态",
            center: true,
            duration: 1500,
            offset: 60,
          });
        }
      });
    },
    checkFamilyTree(callback) {
      let _this = this;
      let loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (loginUser) {
        _this
          .$axios({
            baseURL: apiMap["commonUrl"],
            method: apiMap["fatherTree"]["method"],
            url: apiMap["fatherTree"]["url"],
            params: {
              token: loginUser.token,
              family: 1,
            },
          })
          .then(function(response) {
            callback(response.data.result.statusCode);
          })
          .catch(function(error) {
            console.log(error);
          });
      }
    },
    handleTreeAction(command) {
      if (command.action == 1) {
        var params = {};
        if (command.type == 0) {
          params = { type: "father" };
        } else {
          params = { type: "mother" };
        }
        let routerTreeCard = this.$router.resolve({
          path: "/bigTree",
          query: params,
        });
        window.open(routerTreeCard.href, "_blank");
      } else if (command.action == 2) {
        if (command.type == 0) {
          // this.ExportSavePdf(this.htmlTitle, "#father");
          // this.html2pdf();
        } else {
          // this.ExportSavePdf(this.htmlTitle, "#mother");
        }
      }
    },
    html2pdf() {
      var element = $("#father"); // 这个dom元素是要导出pdf的div容器
      var w = element.width(); // 获得该容器的宽
      var h = element.height(); // 获得该容器的高
      var offsetTop = element.offset().top; // 获得该容器到文档顶部的距离
      var offsetLeft = element.offset().left; // 获得该容器到文档最左的距离
      var canvas = document.createElement("canvas");
      var abs = 0;
      var win_i = $(window).width(); // 获得当前可视窗口的宽度（不包含滚动条）
      var win_o = window.innerWidth; // 获得当前窗口的宽度（包含滚动条）
      if (win_o > win_i) {
        abs = (win_o - win_i) / 2; // 获得滚动条长度的一半
      }
      canvas.width = w * 2; // 将画布宽&&高放大两倍
      canvas.height = h * 2;
      var context = canvas.getContext("2d");
      context.scale(2, 2);
      context.translate(-offsetLeft - abs, -offsetTop);
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉
      html2canvas(document.querySelector("#father"), {
        scale: 1.2,
      }).then(function(canvas) {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        //一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        var leftHeight = contentHeight;
        //页面偏移
        var position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 595.28;
        var imgHeight = (592.28 / contentWidth) * contentHeight;

        var pageData = canvas.toDataURL("image/jpeg", 1.0);

        var pdf = new jsPDF("p", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }

        pdf.save("测试" + new Date().getTime());
        var pdfData = pdf.output("datauristring"); //获取到base64 的pdf
        // console.log(pdfData);
      });
    },
  },
};
</script>
<style scoped>
.tree-tab-container {
  margin-bottom: 10px;
}

.tab-title {
  height: 40px;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 40px;
  letter-spacing: 2px;
  background-color: #1a70db;
}

.tree-item {
  position: relative;
}

.item-menu-wrap {
  position: absolute;
  /* display: none; */
  top: 40px;
  left: 5px;
  background-color: blueviolet;
  box-shadow: 2px 4px 7px #666666;
}

.item-menu-wrap:before {
  position: absolute;
  position: absolute;
  right: 13px;
  top: -23px;
  border: 13px solid rgba(0, 0, 0, 0);
  height: 0;
  width: 0;
  content: "";
  z-index: 1;
  border-bottom-color: #d3250d;
}

.family-tree-wrapper {
  height: 701px;
}

.tree-item:hover .item-menu-wrap {
  display: block;
}

.item-title {
  padding-left: 15px;
  font-size: 15px;
  font-weight: bold;
  font-family: serif;
}

.tree-tab-wrap {
  margin: 20px 0;
  justify-content: space-evenly;
  font-size: 16px;
  text-align: center;
}

.tree-tab-btn {
  cursor: pointer;
  font-size: 16px;
}

.tree-tab-wrap li.active .tree-tab-btn {
  color: #fb6161;
}

/* .view-big-tree {
    display: none;
}

.tree-tab-wrap li.active .view-big-tree {
    display: inline;
} */

.add-member-wrap {
  margin: 15px 0;
  text-align: center;
}

.add-member-btn {
  font-size: 16px;
  color: #1a70db;
}

.not-allowed {
  color: #ccc;
  cursor: not-allowed;
}

.add-member-button {
  margin-left: 15px;
}

.add-member-tip {
  line-height: 25px;
  color: #f00000;
}
.clan-btn-wrap {
  margin-top: 25px;
  text-align: center;
}

.view-clan-btn {
  margin: 0 50px;
  font-size: 15px;
  color: #1a70db;
}

.clan-icon {
  padding-left: 22px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/icon/cl_clan_tree.png");
}

.feed-icon {
  padding-left: 22px;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("../../assets/icon/cl_clan_feed.png");
}
</style>
